import { motion, AnimatePresence } from "framer-motion";
import type { YomaLine } from "../delight";
import yomaAvatar from "@/assets/yoma-avatar.png.asset.json";


/**
 * YoMA — the guide's voice inside the walk. One line per chapter, sitting
 * under the header so the learner always has a friendly presence.
 *
 * Deliberately NOT a result teaser: nothing here reads the answers, so it
 * cannot bias the responses that follow.
 */
export function CompanionNote({ line }: { line: YomaLine | null }) {
  if (!line) return null;
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={line.chapterId}
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="flex items-start gap-2.5"
      >
        <img
          src={yomaAvatar.url}
          alt="YoMA, your guide"
          data-testid="yoma-avatar"
          className="mt-0.5 h-7 w-7 shrink-0 rounded-full object-cover border border-primary/30"
        />

        <p className="text-xs md:text-sm text-muted-foreground leading-snug">
          <span className="text-foreground/80 font-medium">YoMA:</span> {line.nudge}
        </p>
      </motion.div>
    </AnimatePresence>
  );
}
